import React, { useEffect, useState } from "react";
import Popup from "../../../components/common/model/Popup";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../components/common/notification/Notification";
import checkedIcon from "../../../assets/check-mark.png";
import deleteIcon from "../../../assets/trash.png";
import closeIcon from "../../../assets/closeModel.png";
import useStyles from "../../../components/common/model/styles";
import { vehicleTypeFields } from "./vehicleAllFields";
import FormField from "../../../components/common/FormField";
import {
  addVehicleTypeAction,
  getSingleVehicleTypeDetails,
  initialVehicleLocalState,
  initialVehicleTypeLocalState,
  resetNewVehicleTypeLocal,
  setNewVehicleTypeLocal,
} from "../../../store/reducers/vehicleSlice";
import Validation from "../../../utils/Validation";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import ResetFormAlert from "./ResetFormAlert";

interface ManageVehicleTypeProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedVehicle: any; // Adjust type as per your requirement
  action?: any;
  setSelectedVehicle?: any;
}

const ManageVehicleType: React.FC<ManageVehicleTypeProps> = (props) => {
  const classes = useStyles();
  const { open, onHide, title, selectedVehicle, action, setSelectedVehicle } =
    props;
  const fullWidth = true;
  const maxWidth: "sm" | "md" | "lg" | "xl" | false | undefined = "md";
  const [isActionCalled, setIsActionCalled] = useState(false);
  const { newVehicleTypeLocal } = useSelector((state: any) => state.vehicle);
  const [vehicleDetails, setVehicleDetails] = useState<any>(
    initialVehicleTypeLocalState
  );
  const [alertModelShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  const { singleVehicleType } = useSelector((state: any) => state.vehicle);
  const dispatch = useDispatch();

  // Map field ids to validation schema keys (use 'requiredDescription' when description is required)
  const validationKeyMap: Record<string, string> = {
    description: "requiredDescription",
  };
  const getValidationKey = (fieldId: string) =>
    validationKeyMap[fieldId] || fieldId;

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    vehicle_type: vehicleDetails?.vehicle_type,
    requiredDescription: vehicleDetails?.description,
  });

  useEffect(() => {
    if (open && selectedVehicle && Object.keys(selectedVehicle).length > 0) {
      dispatch(getSingleVehicleTypeDetails(selectedVehicle));
    }
  }, [selectedVehicle, open]);

  useEffect(() => {
    if (
      action === "edit" &&
      selectedVehicle &&
      Object.keys(selectedVehicle).length > 0 &&
      singleVehicleType
    ) {
      setVehicleDetails({
        ...singleVehicleType,
      });
      dispatch(
        setNewVehicleTypeLocal({
          ...singleVehicleType,
        })
      );
    } else {
      setVehicleDetails(initialVehicleTypeLocalState);
      dispatch(setNewVehicleTypeLocal(initialVehicleTypeLocalState));
    }
  }, [action]);

  const handleInputChange = (field: string, value: any) => {
    // If input is cleared or contains only spaces, store null instead of ""
    const finalValue =
      value === "" || (typeof value === "string" && value.trim() === "")
        ? null
        : value;

    setVehicleDetails((prevState: any) => ({
      ...prevState,
      [field]: finalValue,
    }));
    // ✅ dispatch Redux action
    dispatch(
      setNewVehicleTypeLocal({
        ...newVehicleTypeLocal,
        [field]: finalValue,
      })
    );
    resetValidator(getValidationKey(field));
  };

  const onBlurAction = (event: any) => {
    checkValidator(getValidationKey(event.target.id));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        if (
          action === "edit" &&
          selectedVehicle &&
          Object.keys(selectedVehicle).length > 0
        ) {
          dispatch(
            addVehicleTypeAction({
              id: selectedVehicle,
              ...newVehicleTypeLocal,
            })
          );
        } else {
          // remove id from payload
          const { id, ...rest } = newVehicleTypeLocal;
          dispatch(addVehicleTypeAction(rest));
        }
        setIsActionCalled(false);
      } else {
        console.log("error in form", error);
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const hideHandler = () => {
    onHide();
    setSelectedVehicle(null);
    setVehicleDetails(initialVehicleTypeLocalState);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    dispatch(setNewVehicleTypeLocal(initialVehicleTypeLocalState));
    resetAllValidator();
  };

  const handleClear = () => {
    if (newVehicleTypeLocal?.id) {
      setVehicleDetails({ ...singleVehicleType });
      dispatch(setNewVehicleTypeLocal({ ...singleVehicleType }));
    } else {
      setVehicleDetails(initialVehicleTypeLocalState);
      dispatch(resetNewVehicleTypeLocal());
    }
    setSelectedVehicle(null);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator();
    setIsClickReset(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              // style={{ right: 40 }}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText
            sx={{
              background: "#E5F4F1",
              padding: "10px 10px 10px 0px",
              border: "1px solid #CFCFCF",
              borderRadius: "5px",
            }}
          >
            <>
              <Notification />
              <Grid container spacing={1}>
                {vehicleTypeFields?.map((field, i) => (
                  <>
                    <FormField
                      key={field.id}
                      onPaste={(e: any) =>
                        field?.id === "name" || field?.id === "email"
                          ? ""
                          : e.preventDefault()
                      }
                      onKeyDown={(event: any) => {
                        if (
                          [8, 9, 37, 38, 39, 40, 18, 17].includes(
                            event.keyCode
                          ) ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...field,
                        value: vehicleDetails ? vehicleDetails[field.id] : "",
                        inSingleGridForm: true,
                        minDate:
                          field.id === "movingOnDate" ? new Date() : undefined,
                        // maxDate:
                        //   field.id === "followUpDate"
                        //     ? newLeadLocal?.movingOnDate &&
                        //       dayjs(newLeadLocal.movingOnDate)
                        //         .toDate()
                        //     : undefined,
                        variant: "outlined",

                        onChange: (e: any) =>
                          handleInputChange(field.id, e.target.value), // Call onChange prop
                        onBlur: onBlurAction,
                        isNonMarginTop: true,
                        GridFieldStyle: {
                          paddingLeft:
                            field.type === "daterangebothvalue" ||
                            field.type === "date"
                              ? "8px !important"
                              : "auto",
                        },
                        InputProps: {
                          ...(field?.inputProps && field?.inputProps),
                          sx:
                            field.type === "text" || field.type === "password"
                              ? { height: "36px" }
                              : { padding: "10px 4px", height: "36px" },
                        },
                        error: error && error[getValidationKey(field.id)],
                      }}
                    />
                  </>
                ))}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alertModelShow && (
        <ResetFormAlert
          open={alertModelShow}
          title=""
          alertModalShow={alertModelShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageVehicleType;
